(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["performance-license-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var configEl = document.getElementById('pl-config');
    var form = document.getElementById('PerformanceLicenseForm');
    if (!configEl || !form) return;

    var CFG = JSON.parse(configEl.textContent);

    // Upper bound of each BMI tier, keyed by SKU. The last tier is open ended.
    var TIER_MAX = {
      'LIC-BMI-T1': 1500,
      'LIC-BMI-T2': 2500,
      'LIC-BMI-T3': 5000,
      'LIC-BMI-T4': Infinity
    };

    var el = function (id) { return document.getElementById(id); };
    var num = function (v) { var n = parseFloat(v); return isNaN(n) ? 0 : n; };
    var money = function (cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\\B(?=(\\d{3})+(?!\\d))/g, ',');
    };

    var f = {
      capacity: el('pl-capacity'),
      admission: el('pl-admission'),
      paidFields: el('pl-paid-fields'),
      price: el('pl-ticket-price'),
      sold: el('pl-tickets-sold'),
      override: el('pl-gross-override'),
      grossWrap: el('pl-gross-wrap'),
      gross: el('pl-gross'),
      date: el('pl-date'),
      time: el('pl-time'),
      dateNote: el('pl-date-note'),
      attest: el('pl-attest'),
      submit: el('pl-submit'),
      error: el('pl-error'),
      outGross: el('pl-out-gross'),
      outAscap: el('pl-out-ascap'),
      outAscapBasis: el('pl-out-ascap-basis'),
      outBmi: el('pl-out-bmi'),
      outBmiBasis: el('pl-out-bmi-basis'),
      outTotal: el('pl-out-total'),
      minNote: el('pl-min-note')
    };

    function timeLabel() {
      if (!f.time || !f.time.value) return '';
      var opt = f.time.options[f.time.selectedIndex];
      return opt ? opt.text.trim() : f.time.value;
    }

    function grossCents() {
      if (f.admission.value === 'free') return 0;
      if (f.override.checked) return Math.round(num(f.gross.value) * 100);
      return Math.round(num(f.price.value) * 100) * Math.round(num(f.sold.value));
    }

    function pickTier(capacity) {
      var tiers = CFG.bmiTiers || [];
      for (var i = 0; i < tiers.length; i++) {
        var max = TIER_MAX[tiers[i].sku];
        if (max === undefined) max = Infinity;
        if (capacity <= max) return tiers[i];
      }
      return tiers[tiers.length - 1] || null;
    }

    function calculate() {
      var capacity = Math.round(num(f.capacity.value));
      var gross = grossCents();
      var free = f.admission.value === 'free';
      var minCents = Math.round(num(CFG.minimumFee) * 100);
      var breakAt = Math.round(num(CFG.rateBreak));

      var ascapCents, basis, atMinimum = false;

      if (free) {
        ascapCents = Math.round(num(CFG.freeAdmissionFee) * 100);
        basis = 'free admission event';
      } else {
        var rate = capacity < breakAt ? num(CFG.rateLow) : num(CFG.rateHigh);
        ascapCents = Math.round(gross * rate);
        basis = capacity ? '(' + money(gross) + ' × ' + rate + ')' : '';
        if (ascapCents < minCents) {
          ascapCents = minCents;
          atMinimum = true;
          basis = 'minimum fee';
        }
      }

      var tier = capacity > 0 ? pickTier(capacity) : null;
      var bmiCents = tier ? tier.cents : 0;

      f.outGross.textContent = free ? 'Free admission' : money(gross);
      f.outAscap.textContent = capacity > 0 || free ? money(ascapCents) : '—';
      f.outAscapBasis.textContent = capacity > 0 || free ? basis : '';
      f.outBmi.textContent = tier ? money(bmiCents) : '—';
      f.outBmiBasis.textContent = tier ? '(' + tier.title + ' seats)' : '';
      f.outTotal.textContent = tier ? money(ascapCents + bmiCents) : '—';
      f.minNote.hidden = !atMinimum;

      return {
        capacity: capacity,
        grossCents: gross,
        free: free,
        ascapCents: ascapCents,
        bmiCents: bmiCents,
        tier: tier,
        totalCents: ascapCents + bmiCents
      };
    }

    function toggleAdmission() {
      var free = f.admission.value === 'free';
      f.paidFields.hidden = free;
      calculate();
    }

    function toggleOverride() {
      f.grossWrap.hidden = !f.override.checked;
      f.price.disabled = f.override.checked;
      f.sold.disabled = f.override.checked;
      calculate();
    }

    function checkDate() {
      if (!f.date.value) { f.dateNote.hidden = true; return; }
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      f.dateNote.hidden = new Date(f.date.value + 'T00:00:00') <= today;
    }

    ['input', 'change'].forEach(function (evt) {
      form.addEventListener(evt, function (e) {
        if (e.target === f.admission) toggleAdmission();
        else if (e.target === f.override) toggleOverride();
        else if (e.target === f.date) { checkDate(); }
        else calculate();
      });
    });

    function showError(msg) {
      f.error.textContent = msg;
      f.error.hidden = false;
      f.error.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function firstInvalid() {
      var required = form.querySelectorAll('[required]');
      for (var i = 0; i < required.length; i++) {
        var input = required[i];
        if (input.offsetParent === null) continue; // hidden fields don't count
        var bad = input.type === 'checkbox' ? !input.checked : !String(input.value).trim();
        input.setAttribute('aria-invalid', bad ? 'true' : 'false');
        if (bad) return input;
      }
      return null;
    }

    function properties(calc) {
      var v = function (id) { var n = el(id); return n ? String(n.value).trim() : ''; };
      var props = {
        'Name of chorus, quartet, or region': v('pl-chapter'),
        'Region #': v('pl-region-num'),
        'Date of performance': v('pl-date'),
        'Time of performance': timeLabel(),
        'Facility': v('pl-facility'),
        'Facility location': v('pl-city') + (v('pl-state') ? ', ' + v('pl-state') : ''),
        'Seating capacity': String(calc.capacity),
        'Admission': calc.free ? 'Free admission' : 'Tickets sold',
        'Gross revenue': calc.free ? 'Free admission' : money(calc.grossCents),
        'ASCAP fee': money(calc.ascapCents),
        'BMI fee': money(calc.bmiCents),
        'Total license fee': money(calc.totalCents),
        'License recipient': v('pl-recipient-name'),
        'Recipient member #': v('pl-member-num'),
        'Recipient email': v('pl-recipient-email'),
        'Recipient phone': v('pl-recipient-phone'),
        'Recipient address': v('pl-recipient-address')
      };
      if (!calc.free) {
        props['Ticket price'] = f.override.checked ? 'Multiple prices' : money(Math.round(num(f.price.value) * 100));
        props['Tickets sold'] = f.override.checked ? 'n/a' : String(Math.round(num(f.sold.value)));
      }
      // Drop empties so the order and confirmation email stay readable.
      Object.keys(props).forEach(function (k) {
        if (!props[k]) delete props[k];
      });
      return props;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      f.error.hidden = true;

      var bad = firstInvalid();
      if (bad) {
        bad.focus();
        showError(bad.type === 'checkbox'
          ? 'Please confirm the statement at the bottom of the form before continuing.'
          : 'Please fill in the highlighted field.');
        return;
      }

      var calc = calculate();
      if (!calc.capacity || calc.capacity < 1) {
        f.capacity.focus();
        showError('Please enter the seating capacity of the venue.');
        return;
      }
      if (!calc.tier) {
        showError('We could not determine the BMI fee for that seating capacity. Please contact Music Services.');
        return;
      }
      if (!calc.free && calc.grossCents <= 0) {
        showError('Please enter the ticket price and number of tickets sold, or choose "Free admission event".');
        return;
      }
      var ascapQty = Math.round(calc.ascapCents / (CFG.ascapUnitCents || 1));
      if (ascapQty < 1) {
        showError('The calculated ASCAP fee is invalid. Please contact Music Services.');
        return;
      }

      var props = properties(calc);
      // Unique token keeps each license separate when several are in one cart.
      var token = 'L' + Date.now().toString(36).toUpperCase();
      var label = props['Name of chorus, quartet, or region'] + ' — ' + props['Date of performance'] + ' — ' + (props['Time of performance'] || '');

      props['_license_ref'] = token;

      var payload = {
        items: [
          { id: CFG.parentVariantId, quantity: 1, properties: props },
          { id: CFG.ascapVariantId, quantity: ascapQty, properties: { 'License': label, '_license_ref': token } },
          { id: calc.tier.id, quantity: 1, properties: { 'License': label, '_license_ref': token } }
        ]
      };

      f.submit.disabled = true;
      f.submit.textContent = 'Adding…';

      fetch(window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          return res.json().then(function (body) {
            if (!res.ok) throw new Error(body.description || body.message || 'Could not add the license to your cart.');
            return body;
          });
        })
        .then(function () {
          window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart';
        })
        .catch(function (err) {
          f.submit.disabled = false;
          f.submit.textContent = 'Add license to cart';
          showError(err.message || 'Something went wrong. Please try again or contact Music Services.');
        });
    });

    toggleAdmission();
    toggleOverride();
    calculate();
  })();

  } catch(e) { console.error(e); }
})();
})();
